import { render, staticRenderFns } from "./safePictures.vue?vue&type=template&id=45e4b157&scoped=true&"
import script from "./safePictures.vue?vue&type=script&lang=js&"
export * from "./safePictures.vue?vue&type=script&lang=js&"
import style0 from "./safePictures.vue?vue&type=style&index=0&id=45e4b157&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e4b157",
  null
  
)

export default component.exports